import { useEffect, useState } from "react";
import { useContext } from "react";
import StateContext from "../context/StateContext";
import useSegments from "./useSegments";
import { captureException } from "services/sentry";

const usePlanUsage = () => {
	const { segMap, hitsMap, dispatch, ACTIONS } = useContext(StateContext);
	const { getSegmentHits } = useSegments();
	const [sessions, setSessions] = useState({});

	const checkIfHasTimeFrame = async () => {
		const dontHaveHits = hitsMap && Object.keys(hitsMap).some((code) => !hitsMap[code].hasOwnProperty("THIS_MONTH"));
		if (dontHaveHits) {
			try {
				dispatch({ type: ACTIONS.SET_SPINNER, payload: true });
				const { newHitsMap } = await getSegmentHits("THIS_MONTH");
				if (newHitsMap) {
					dispatch({
						type: ACTIONS.SET_STATE,
						payload: { hitsMap: newHitsMap, showSpinner: false }
					});
				}
			} catch (e) {
				dispatch({ type: ACTIONS.SET_SPINNER, payload: false });
				console.error("SubscribePlan.js ~ getThisMonthUsage ~ error", e.message || e);
				captureException(e, "log", {}, { action: "checkIfHasTimeFrame" }, { scope: "usePlanUsage.js" });
			}
			return;
		}
	};
	const getThisMonthUsage = async () => {
		let totalSessionsPerPlan = {};
		if (!(hitsMap && segMap)) return;
		for (let segCode in hitsMap) {
			const seg = segMap[segCode];
			const segTotalHits = hitsMap[segCode].THIS_MONTH?.total;
			totalSessionsPerPlan[seg?.plan_id] = totalSessionsPerPlan.hasOwnProperty(seg?.plan_id) ? totalSessionsPerPlan[seg?.plan_id] + segTotalHits : segTotalHits;
		}
		return setSessions(totalSessionsPerPlan);
	};
	useEffect(() => {
		getThisMonthUsage();
	}, [hitsMap]);

	useEffect(() => {
		checkIfHasTimeFrame();
	}, []);
	return sessions;
};
export default usePlanUsage;
